// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cart-checkout__shipping',
    // #endregion
    // #region Events
    emits: ["command"],
    // #endregion
    // #region Properties
    props: {
        cart: {
            type: Object,
            required: false,
            default: {}
        },
        schema: {
            type: Object,
            required: false,
            default: {}
        },
        data: {
            type: Object,
            required: false,
            default: {}
        },
        status: {
            type: Object,
            required: true,
            default: {}
        }
    },
    // #endregion
    // #region Constructor
    beforeMount() {
        this.$host.eventBus.on('checkout-before-commit', this.OnCartNext);
    },
    beforeUnmount() {
        this.$host.eventBus.off('checkout-before-commit', this.OnCartNext);
    },
    // #endregion
    // #region Events
    methods: {
        async OnCartNext(args) {
            // #region Form
            let tForm = this.$refs?.frmMain?.$form;
            if (tForm && !tForm.validate()) {
                args.cancel = true;
            }
            // #endregion           
        }
    }
    // #endregion
});
// #endregion
